import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

const Loading = ({ loading, color, size, height, mt, showText, flex }) => {
  return (
    <div
      className={`loading-container ${flex ? "flex__container" : ""}`}
      style={{ height: height && "100vh", marginTop: mt && "30px" }}
    >
      <ClipLoader
        color={color ? color : "#ffffff"}
        loading={loading}
        size={size ? size : 20}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {showText && <p>Please Wait...</p>}
    </div>
  );
};

export default Loading;
